__turbopack_context__.v({
  "divider": "PolicyLayout-module__VIe4uW__divider",
  "eyebrow": "PolicyLayout-module__VIe4uW__eyebrow",
  "inlineLinkCard": "PolicyLayout-module__VIe4uW__inlineLinkCard",
  "metaGrid": "PolicyLayout-module__VIe4uW__metaGrid",
  "pageLead": "PolicyLayout-module__VIe4uW__pageLead",
  "pageTitle": "PolicyLayout-module__VIe4uW__pageTitle",
  "policyContainer": "PolicyLayout-module__VIe4uW__policyContainer",
  "policyPage": "PolicyLayout-module__VIe4uW__policyPage",
  "section": "PolicyLayout-module__VIe4uW__section",
  "sectionBody": "PolicyLayout-module__VIe4uW__sectionBody",
  "sectionTitle": "PolicyLayout-module__VIe4uW__sectionTitle",
  "timelineTable": "PolicyLayout-module__VIe4uW__timelineTable",
});
